import {
  AdminFonctionnelControllerApi,
  DossierControllerApi,
  DossierDtoAdminFonctionnel,
  DossierResponseDto,
  ErrorDtoCodeEnum,
} from 'lib_api/lib/api/gen';

import { openNotification } from 'hooks/utils/backAlertMessage';
import { getErrorDtoOrThrow } from 'typeGuards/typeGuards';
import { backErrorMessages } from 'utils/ErrorMessages';

const notificationMessage =
  'Doublon détecté lors de la mise à jour de la fourrière de rattachement';

export async function displayNotificationForAdminIfDoublonOrElseThrow(
  response: Response,
  dossierController: AdminFonctionnelControllerApi,
  dossierId: string,
): Promise<DossierDtoAdminFonctionnel> {
  let errorBody;
  try {
    errorBody = getErrorDtoOrThrow(await response.json());
  } catch (e) {
    console.error(e);
  }
  if (
    errorBody &&
    errorBody.code ===
      ErrorDtoCodeEnum.DOSSIER_UPDATE_FOURRIERE_RATTACHEMENT_DOUBLON_DOSSIER_ERROR
  ) {
    openNotification(
      notificationMessage,
      {
        description: backErrorMessages[errorBody.code],
      },
      false,
    );
    return dossierController.getInformationsByDossierIdUsingGET(dossierId);
  }
  throw response;
}
export async function displayNotificationForOthersIfDoublonOrElseThrow(
  response: Response,
  dossierController: DossierControllerApi,
  dossierId: string,
): Promise<DossierResponseDto> {
  let errorBody;
  try {
    errorBody = getErrorDtoOrThrow(await response.json());
  } catch (e) {
    console.error(e);
  }
  if (
    errorBody &&
    errorBody.code ===
      ErrorDtoCodeEnum.DOSSIER_UPDATE_FOURRIERE_RATTACHEMENT_DOUBLON_DOSSIER_ERROR
  ) {
    openNotification(
      notificationMessage,
      {
        description: backErrorMessages[errorBody.code],
      },
      false,
    );
    return dossierController.getByIdUsingGET(dossierId);
  }
  throw response;
}
